import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ResponsePregunta } from 'src/app/models/response_pregunta.model';
import { Resultat } from 'src/app/models/resultat.model';
import { RumiService } from 'src/app/services/rumi.service';
import { UtilitatsService } from 'src/app/services/utilitats.service';

@Component({
  selector: 'app-altres-observacions',
  templateUrl: './altres-observacions.component.html'
})
export class AltresObservacionsComponent implements OnInit {

  public altresObservacionsForm: FormGroup;
  
  public get valoracions(){
    return this.rumiService.valoracions;
  }

  constructor(
    public translate: TranslateService,
    private router: Router,
    private rumiService: RumiService,
    private _fb: FormBuilder,
    private utilService: UtilitatsService
  ) { }

  ngOnInit() {
    this.rumiService.pestanyaActiva = this.router.url;
    this.initAltresObservacionsForm();
  }

  goToNextStep() {
    this.sync();
    console.log(this.rumiService.simulacio);
    this.utilService.showSpinner('Carregant dades...');
    this.rumiService.getResultatAlgorisme().subscribe((res: Resultat) => {
      this.utilService.hideSpinner();
      console.log(res);
      this.rumiService.simulacio.resultat = res;
      this.router.navigate(['simulacio','resultat-risc']);
    });
  }

  goToPrevStep() {
    this.sync();
    this.router.navigate(['simulacio','valoracions-finals']);
  }

	navigate(url: String){
	  this.router.navigate([url]);
	}
  
  initAltresObservacionsForm() {
    this.altresObservacionsForm = this._fb.group({
      factorsPregunta: [this.rumiService.simulacio.factorsPregunta.idsRespostes, []],
      altresFactorsObservacions: [this.rumiService.simulacio.altresFactorsObservacions.descripcioResposta, []]
    });    
  }

  private sync(){
    if(this.rumiService.simulacio != null) {
      var resposta;
      
      this.rumiService.simulacio.factorsPregunta = new ResponsePregunta();
      this.rumiService.simulacio.factorsPregunta.id = this.rumiService.valoracions[8].preguntes[0].id;
      this.rumiService.simulacio.factorsPregunta.descripcioPregunta = this.rumiService.valoracions[8].preguntes[0].descripcio;
      this.rumiService.simulacio.factorsPregunta.tipusPregunta = this.rumiService.valoracions[8].preguntes[0].tipusPregunta;
      resposta = this.altresObservacionsForm.get('factorsPregunta').value;
      if(resposta != ''){
        this.rumiService.simulacio.factorsPregunta.idsRespostes = resposta;
        let descripcioResposta = '';
        this.valoracions[8].preguntes[0].respostes.forEach(resposta=>{
          if(this.rumiService.simulacio.factorsPregunta.idsRespostes.includes(resposta.id)){
            if(descripcioResposta == ''){
              descripcioResposta += resposta.descripcio;
            }else{
              descripcioResposta += ', '+resposta.descripcio;
            }
          }
        });
        this.rumiService.simulacio.factorsPregunta.descripcioResposta = descripcioResposta;
      }

      resposta = this.altresObservacionsForm.get('altresFactorsObservacions').value
      this.rumiService.simulacio.altresFactorsObservacions = new ResponsePregunta();
      this.rumiService.simulacio.altresFactorsObservacions.id = this.rumiService.valoracions[7].preguntes[0].id;
      this.rumiService.simulacio.altresFactorsObservacions.descripcioPregunta = this.rumiService.valoracions[7].preguntes[0].descripcio;
      this.rumiService.simulacio.altresFactorsObservacions.tipusPregunta = this.rumiService.valoracions[7].preguntes[0].tipusPregunta;      
      this.rumiService.simulacio.altresFactorsObservacions.descripcioResposta = resposta;
    }

  }

}
